import { rem } from "polished";
import styled from "styled-components";

import type { ImagePosition } from "@/components/editor/image-positioner/image-positioner-component";
import type { ImageFit } from "@/components/editor/shared/header/header-settings-component";
import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";

export const Image = styled.img<{
  $position: ImagePosition;
  imageFit?: ImageFit;
}>`
  width: 100%;
  height: 100%;
  object-fit: ${({ imageFit }) => imageFit || "cover"};
  object-position: ${({ $position }) => $position};
  overflow: hidden;
`;

export const LogoWrapper = withViewportStyle("div")`
  height: 100%;
  display: flex;
  align-items: center;

  ${(props) => props.$viewport.tablet`
    justify-content: center;
  `}
`;

export const Logo = withViewportStyle("img")<{
  isLogoResized: boolean;
}>`
  max-height: ${({ isLogoResized }) => (isLogoResized ? rem(120) : rem(40))};
  max-width: 100%;
  object-fit: contain;

  ${(props) => props.$viewport.tablet`
    max-height: ${({ isLogoResized }) => (isLogoResized ? rem(100) : rem(35))};
  `}

  ${(props) => props.$viewport.mobile`
    max-height: ${({ isLogoResized }) => (isLogoResized ? rem(80) : rem(31))};
  `}
`;

export const RichTextContainer = withViewportStyle("div")`
  display: grid;
  grid-template-columns: 1fr;
  row-gap: ${rem(24)};

  .ck-content h1,
  .ck-content h2,
  .ck-content h3,
  .ck-content h4,
  .ck-content h5,
  .ck-content p,
  .ck-content li {
    margin: 0;
  }

  ${(props) => props.$viewport.tablet`
    .ck-content h1,
    .ck-content h2,
    .ck-content h3,
    .ck-content h4,
    .ck-content h5,
    .ck-content p,
    .ck-content li {
      text-align: center;
    }
  `}
`;
